import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { User } from "src/types/api";

export type InitialState = {
  user: null | User;
};

const initialState: InitialState = {
  user: null,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setUserProfile: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
  },
});

export const { setUserProfile } = profileSlice.actions;

export default profileSlice.reducer;
